import React from "react";
import {
    ColoredAnchor,
    ColoredLink,
    Desc,
    IntroImgTitle,
    IntroQuote,
    IntroQuoteText,
    StyledSource,
    StyledVideo,
    StyledVideoFront,
    Subtitle,
    SubtitleWord,
    Title,
    TitleContainer,
    VideoContainer,
    VideoFlexContainer,
} from "./Intro.styles";
import Logo from "../../components/logos/Logo/Logo";
import { ColoredText } from "../../parts/Navbar/Navbar.styles";
import { MAIN_COLOR } from "../../components/globalThemes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import "./Intro.styles.css";
import {
    FACEBOOK_PAGE,
    MAIN_DESCRIPTION,
    SHORT_NAME,
    SHORT_NAME_TEAM,
    TEAM_DATE,
} from "../../utils/info";

const Intro = () => {
    return (
        <VideoContainer>
            <StyledVideo autoPlay muted loop>
                <StyledSource
                    src={"/videos/football-club.mp4"}
                    type={"video/mp4"}
                />
            </StyledVideo>
            <VideoFlexContainer>
                <IntroImgTitle>
                    <Logo width={250} height={250} />
                    <TitleContainer>
                        <Title>
                            <ColoredText color={MAIN_COLOR}>
                                {SHORT_NAME}
                            </ColoredText>
                            {` ${SHORT_NAME_TEAM}`}
                        </Title>
                        <Subtitle>{`z Wami od ${TEAM_DATE} roku`}</Subtitle>
                    </TitleContainer>
                </IntroImgTitle>
                <Desc>{MAIN_DESCRIPTION}</Desc>
                <SubtitleWord />
                <IntroQuote>
                    <FontAwesomeIcon
                        icon={faBell}
                        color={MAIN_COLOR}
                        className={"bell"}
                    />
                    <IntroQuoteText>
                        {"Śledź naszą oficjalną "}
                        <ColoredLink color={MAIN_COLOR} to={"/news"}>
                            {"sekcję aktualności"}
                        </ColoredLink>
                        {" oraz "}
                        <ColoredAnchor
                            color={MAIN_COLOR}
                            href={FACEBOOK_PAGE}
                            target={"_blank"}
                        >
                            {"grupę na Facebooku"}
                        </ColoredAnchor>
                        {" by być zawsze na bieżąco!"}
                    </IntroQuoteText>
                </IntroQuote>
            </VideoFlexContainer>
            <StyledVideoFront />
        </VideoContainer>
    );
};

export default Intro;
